import { Field, useFormikContext } from 'formik';
import React, { FC } from 'react';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { getLocationTypeNames } from '../../services/locationTypeService';
import { getModeTypeNames } from '../../services/modeTypeService';
import { getThreatLevelNames } from '../../services/threatLevelService';
import Label from '../label/label';
import { DEF_PG_SIZE_FILTER } from '../../constants/maximum-page-size';
import PaginatedSearchableSelectField from '../selection-field/paginated-searchable-select-field';
import { ListQuery } from '../../models/ListQuery';
import { MODE_TYPE_SUPPORTED_BY_IO_MODULE } from '../../constants/mode-type';
import { appendFilter } from '../../utilities/filters';

export const IOModuleDetails: FC = () => {
    const { translate } = useLocale();
    const { setFieldValue, values } = useFormikContext<any>();

    return <div>
        <div className="flex flex-row">
            <div className="flex flex-col flex-1 pr-3">
                <Label htmlFor='type'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.type)}:</Label>
                <Field
                    name="type"
                    type="text"
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
            </div>

            <div className="flex flex-col flex-1 pr-3">
                <Label htmlFor='site'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.site)}:</Label>
                <Field
                    name="site"
                    type="text"
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
            </div>
        </div>

        <div className="flex flex-row flex-1 pt-3 ">
            <div className="flex flex-col flex-1 pr-3">
                <Label htmlFor='defaultModeId'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.defaultMode)}:</Label>
                <PaginatedSearchableSelectField
                    name={translate.byKey(TranslationKeys.defaultMode)}
                    key={"defaultModeId"}
                    accessor='defaultModeId'
                    pageSize={DEF_PG_SIZE_FILTER}
                    dataMethod={(listParameters?: ListQuery) => getModeTypeNames({ ...listParameters, filters: appendFilter(MODE_TYPE_SUPPORTED_BY_IO_MODULE.map(modeSetting => modeSetting.modeTypeId).join(","), "Mode Type Id", "id", listParameters?.filters ?? []) })}
                    searchAccessor={'trnName'}
                    onSelect={(event, item) => {
                        setFieldValue('defaultMode', item?.label);
                        setFieldValue('defaultModeId', item?.value);
                    }}
                    selectedItemLabel={values.defaultMode} />
            </div>

            <div className="flex flex-col flex-1 pr-3">
                <Label htmlFor='functionId'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.function)}:</Label>
                <PaginatedSearchableSelectField
                    name={translate.byKey(TranslationKeys.function)}
                    key={"functionId"}
                    accessor='functionId'
                    dataMethod={getLocationTypeNames}
                    searchAccessor={'ltName'}
                    onSelect={(event, item) => {
                        setFieldValue('function', item?.label);
                        setFieldValue('functionId', item?.value);
                    }}
                    selectedItemLabel={values.function} />
            </div>
        </div>

        <div className="flex flex-row flex-1 pt-3">
            <div className="flex flex-col flex-1 pr-3">
                <Label htmlFor='version'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.version)}:</Label>
                <Field
                    name="version"
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
            </div>
            <div className="flex flex-col flex-1 pr-3">
                <Label htmlFor='threatLevelId'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.threatLevel)}:</Label>
                <PaginatedSearchableSelectField
                    name={translate.byKey(TranslationKeys.threatLevel)}
                    key={"threatLevelId"}
                    accessor='threatLevelId'
                    dataMethod={getThreatLevelNames}
                    searchAccessor={'tlName'}
                    onSelect={(event, item) => {
                        setFieldValue('threatLevel', item?.label);
                        setFieldValue('threatLevelId', item?.value);
                    }}
                    selectedItemLabel={values.threatLevel} />
            </div>
        </div>
    </div>;
};
